import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const CardOuter = styled(Box)({
  position: "relative",
  width: "100%",
  maxWidth: 720,
  margin: "0 auto",
});

const Card = styled(Box, { shouldForwardProp: (p) => p !== "phase" })(({ phase }) => ({
  background: "#fff",
  borderRadius: 16,
  padding: "40px 48px",
  boxShadow: "0 16px 36px rgba(46,196,182,0.25)",
  border: "2px solid rgba(46,196,182,0.35)",
  textAlign: "center",
  position: "relative",
  overflow: "hidden",
  willChange: "transform, opacity",
  transition: "transform 0.4s cubic-bezier(.4,0,.2,1), opacity 0.35s ease",
  transform:
    phase === "entering" ? "translateX(100%)" :
    phase === "exiting" ? "translateX(-100%)" :
    "translateX(0)",
  opacity: phase === "exiting" ? 0 : 1,
}));

const Accent = styled(Box)({
  position: "absolute",
  top: 0, left: 0, right: 0,
  height: 6,
  background: "linear-gradient(90deg, #ffe066 0%, #2ec4b6 100%)",
});

const Header = styled(Typography)({
  fontFamily: "Helvetica Inserat",
  color: "#1a7a72",
  fontSize: "3.2rem",
  letterSpacing: "0.15em",
  textTransform: "uppercase",
  fontWeight: 900,
  lineHeight: 1.05,
});

const SubHeader = styled(Typography)({
  fontFamily: "Helvetica Inserat",
  color: "#222",
  fontSize: "2.2rem",
  margin: "8px 0 16px",
});

const Winner = styled(Typography)({
  fontFamily: "Helvetica Inserat",
  color: "#222",
  fontSize: "5rem",
  lineHeight: 1,
  margin: "16px 0 12px",
});

const WinnerDetail = styled(Typography)({
  color: "#5f5f5f",
  fontSize: "1.2rem",
});

/**
 * role:
 *   "incoming" -> mount at translateX(100%), animate to translateX(0)
 *   "outgoing" -> mount at translateX(0), animate to translateX(-100%) + fade
 *
 * Each instance is keyed by superlative.id by the parent, so it mounts/unmounts cleanly.
 */
const SpotlightCard = ({ superlative, role = "incoming" }) => {
  const initialPhase = role === "outgoing" ? "shown" : "entering";
  const targetPhase = role === "outgoing" ? "exiting" : "shown";
  const [phase, setPhase] = useState(initialPhase);

  useEffect(() => {
    const id1 = requestAnimationFrame(() => {
      requestAnimationFrame(() => setPhase(targetPhase));
    });
    return () => cancelAnimationFrame(id1);
  }, [targetPhase]);

  if (!superlative) return null;

  return (
    <CardOuter>
      <Card phase={phase}>
        <Accent />
        <Header>{superlative.header}</Header>
        <SubHeader>{superlative.subhead}</SubHeader>
        <Winner>{superlative.winner}</Winner>
        {superlative.winnerDetail && (
          <WinnerDetail>{superlative.winnerDetail}</WinnerDetail>
        )}
      </Card>
    </CardOuter>
  );
};

export default SpotlightCard;
